import { render } from "./FieldList.vue?vue&type=template&id=0ff6d83a"
import script from "./FieldList.vue?vue&type=script&lang=js"
export * from "./FieldList.vue?vue&type=script&lang=js"

import "./FieldList.vue?vue&type=style&index=0&id=0ff6d83a&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__